const ENGLISH_LOCALE_KEYS = new Set(['english', 'en', 'en-us', 'en_us']);

export const sanitizeSurveyTranslationForLocale = (
  value: string | null | undefined,
  localeKey: string | null | undefined,
): string | null => {
  if (value == null) {
    return null;
  }

  const normalizedLocale = String(localeKey || '').toLowerCase();
  if (!ENGLISH_LOCALE_KEYS.has(normalizedLocale)) {
    return value;
  }

  return /[가-힣]/.test(value) ? null : value;
};
